import { BufferGeometry, type Mesh } from "three"
import loadSingleModelAndMerge from "../../../fn/loadSingleModelAndMerge"
import { Quaternius_UltimateNaturePack_Willow_Willow_1_GLTF_Model, Quaternius_UltimateNaturePack_Willow_Willow_4_GLTF_Model, Quaternius_UltimateNaturePack_Willow_Willow_5_GLTF_Model } from "../../../gltf_models.generated"
import creaseMeshGeometryNormals from "../../../fn/creaseMeshGeometryNormals"

// Cache for loaded geometries
let cachedPromise: Promise<BufferGeometry[]> | undefined

function meshTest (mesh: Mesh) {
  creaseMeshGeometryNormals(mesh)
  return true
}

export default function loadAndMergeSwampTreeGeometry(): Promise<BufferGeometry[]> {
  if (!cachedPromise) {
    // console.log('Loading swamp tree models...')
    
    cachedPromise = Promise.all([
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_1_GLTF_Model, 1.3, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_4_GLTF_Model, 1.3, meshTest),
      loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Willow_Willow_5_GLTF_Model, 1.3, meshTest),
    ])
  }

  return cachedPromise
}
